/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function DocumentsIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "documents", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M16.5 6.5H19.5V21.5H8.5V18.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 3.5H16.5V18.5H5.5V8L10 3.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 3.5V8H5.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(DocumentsIcon);
export default ForwardRef;
//# sourceMappingURL=documentsIcon.js.map